import { ReactElement, useMemo } from "react";

import { formatFilterMainOption } from "../pages/main/initialState";
import { useFilter } from "../../../../../hooks/filter";
import { OptionGroupContext } from "../context";

const OptionGroupProvider = ({ children }: { children: ReactElement }) => {

    const filterMain = useFilter({ formatFilter: formatFilterMainOption })


    const value = useMemo(() => ({
        filterMain
    }), [ filterMain ]);

    return (
        <OptionGroupContext.Provider value={value}>
            {children}
        </OptionGroupContext.Provider>
    );
};

export { OptionGroupProvider };